export const addRules = {
  menuName: [
    { required: true, message: '请输入菜单名称!', trigger: 'blur' }
  ],
  url: [
    { required: true, message: '请输入菜单路径!', trigger: 'blur' }
  ]
}

export const modifyRules = {
  name: [
    { required: true, message: '请输入菜单名称!', trigger: 'blur' }
  ],
  path: [
    { required: true, message: '请输入菜单路径!', trigger: 'blur' }
  ]
}
